module.exports = __webpack_public_path__ + "img/ye.b5840a84.svg";